export default "/images/vendor/quill/icons/float-center.svg?5793f183d1a93dc6f65ee9872c887088";